import Header from "@arelia-components/layout/Header";
import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";
import FansListPresenter from "./FansListPresenter";
import { useHqFansAPI } from "./hq-fans.api";
import { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PATHS } from "src/routes";
import { FANS_UPDATE_EVENT_NAME } from "./constant";
import useEventListeners from "@arelia-hooks/useEventListeners";
import { getFansNavOptions } from "../constant";
import { useConfiguration } from "src/api/configuration";
import AppContext from "src/AppContext";

export default function FansListContainer() {
  const { pathname } = useLocation();
  const { data: config } = useConfiguration();
  const { account } = useContext(AppContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === PATHS.FANS) {
      navigate(PATHS.FANS_DASHBOARD);
    }
  }, [pathname]);

  const { data: fans, isLoading, refetch } = useHqFansAPI();
  const navOptions = getFansNavOptions(config?.flags ?? {}, account?.plan);

  useEventListeners([
    FANS_UPDATE_EVENT_NAME
  ], () => {
    refetch();
  });

  return (
    <ContentBox>
      <Header
        title="My Fans"
        navOptions={navOptions}
        navValue={pathname}
        setNavValue={navigate}
      />

      <SpinnerWrapper loading={isLoading}>
        <FansListPresenter fans={fans || []} />
      </SpinnerWrapper>
    </ContentBox>
  );
}